import React from "react";
import PropTypes from "prop-types";
import Contributor from "../../../../../atoms/contributor";

import { get } from "lodash";

import Icon from "../../../../../atoms/icon";
import { Link } from "@quintype/components";

import { isPremium } from "../../../../../../../isomorphic/data/story";

import styles from "./styles.m.css";
import SocialShareSection from "../../../../../atoms/social-share-section";
// import { time } from "console";

class StoryHeader extends React.Component {
  constructor(props) {
    super(props);

    this.dropdown = null;

    this.state = {
      dropdown: false,
      showRelativeTime: false
    };

    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleExternalClick = this.handleExternalClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleExternalClick);
    this.setState({ showRelativeTime: true });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleExternalClick);
  }

  handleExternalClick(e) {
    this.setState({ dropdown: false });
  }

  handleDropdownClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const {
      story,
      renderSocialMedia = () => null,
      episodes,
      className,
      config,
      subheadline = true,
      readMore = true,
      cartoon = false,
      readTimeshow = false
    } = this.props;

    const readTime = get(this.props, ["story", "read-time"], () => null);
    const uniqueIds = [];

    const uniqueEpisodes =
      episodes &&
      episodes.filter(episode => {
        const isDuplicate = uniqueIds.includes(episode.id);

        if (!isDuplicate) {
          uniqueIds.push(episode.id);

          return true;
        }

        return false;
      });

    return (
      <div>
        <div className={`${styles["story-header"]} ${className}`}>
          {story.headline && <h1 className={styles.headline}>{story.headline}</h1>}
          {!isPremium(story)}

          {readMore === true && story.authors && story.authors.length ? (
            <div className={styles.contributors}>
              <div className={styles.contributorOuter}>
                <SocialShareSection story={story} config={config} />
              </div>
              {cartoon === true && readTimeshow === true ? (
                ""
              ) : (
                <div className={styles["mins-read"]} story={story} config={config}>
                  {readTime} Min Read
                </div>
              )}
            </div>
          ) : null}
          {readMore === true &&
            episodes && (
              <div className={styles["episode-dropdown-base"]}>
                <button
                  aria-label="toggle dropdown"
                  role="button"
                  className={styles["selected-episode"]}
                  onClick={this.handleDropdownClick}
                  ref={element => {
                    this.dropdown = element;
                  }}
                >
                  <span className={styles["selected-episode-text"]}>தொடரின் பிற அத்தியாயங்களைப் படிக்க</span>
                  <Icon type={this.state.dropdown ? "angle-up" : "angle-down"} className={styles["dropdown-icon"]} />
                </button>
                <div className={`${styles["episode-popup"]} ${this.state.dropdown ? "" : "hidden"}`}>
                  <ul className={`${styles["episodes-dropdown"]}`}>
                    {uniqueEpisodes.map(episode => (
                      <li key={episode.id} className={styles.episode}>
                        <Link aria-label="Episode" href={episode.url} className={styles["episode-link"]}>
                          {episode.headline}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          {renderSocialMedia("show-mobile-and-tablet")}
          {story.subheadline && subheadline ? (
            <p className={`${styles["mobile-hide"]} ${styles["sub-headline"]}`}>{story.subheadline}</p>
          ) : null}
        </div>
      </div>
    );
  }
}

StoryHeader.propTypes = {
  story: PropTypes.shape({
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    headline: PropTypes.string,
    subheadline: PropTypes.string,
    contributor: PropTypes.shape(Contributor.propTypes)
  }),
  episodes: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  renderSocialMedia: PropTypes.func,
  className: PropTypes.string,
  config: PropTypes.shape({
    cinemaMode: PropTypes.bool,
    disableAuthorLink: PropTypes.bool
  }),
  subheadline: PropTypes.bool,
  readMore: PropTypes.bool,
  cartoon: PropTypes.bool,
  readTimeshow: PropTypes.bool
};

export default StoryHeader;
